import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 内容&课程部分
 *
 */


/**
 * 课程查询：列表
 * @param {*} query
 */
export const courseList = (query) => {
  return request({
    url: `${prefix}/course/list`,
    method: 'get',
    params: query
  })
}

/**
 * 课程查询
 * @param {*} query
 */
export const courseOne = (query) => {
  return request({
    url: `${prefix}/course`,
    method: 'get',
    params: query
  })
}

/**
 * 课程创建
 * @param {*} query
 */
export const courseCreate = (query) => {
  return request({
    url: `${prefix}/course`,
    method: 'post',
    data: query
  })
}

/**
 * 课程修改
 * @param {*} query
 */
export const courseUpdate = (query) => {
  return request({
    url: `${prefix}/course`,
    method: 'put',
    data: query
  })
}

/**
 * 课程修改 多行
 * @param {*} query
 */
export const coursesUpdate = (query) => {
  return request({
    url: `${prefix}/courses`,
    method: 'put',
    data: query
  })
}

/**
 * 课程修改状态
 * @param {*} query
 */
export const courseUpdateStatus = (query) => {
  return request({
    url: `${prefix}/course/status`,
    method: 'put',
    data: query
  })
}

/**
 * 课程删除
 * @param {*} query
 */
export const courseDestroy = (query) => {
  return request({
    url: `${prefix}/course`,
    method: 'delete',
    data: query
  })
}

/**
 * 课程删除 真
 * @param {*} query
 */
export const courseRemove = (query) => {
  return request({
    url: `${prefix}/course/remove`,
    method: 'delete',
    data: query
  })
}

/**
 * 课程恢复
 * @param {*} query
 */
export const courseRestore = (query) => {
  return request({
    url: `${prefix}/course/restore`,
    method: 'post',
    data: query
  })
}

/**
 * 课程克隆
 * @param {*} query
 */
export const courseClone = (query) => {
  return request({
    url: `${prefix}/course/clone`,
    method: 'post',
    data: query
  })
}

/**
 * 课程章节查询：列表
 * @param {*} query
 */
export const courseChapterList = (query) => {
  return request({
    url: `${prefix}/courseChapter/list`,
    method: 'get',
    params: query
  })
}

/**
 * 课程章节查询
 * @param {*} query
 */
export const courseChapterOne = (query) => {
  return request({
    url: `${prefix}/courseChapter`,
    method: 'get',
    params: query
  })
}

/**
 * 课程章节创建
 * @param {*} query
 */
export const courseChapterCreate = (query) => {
  return request({
    url: `${prefix}/courseChapter`,
    method: 'post',
    data: query
  })
}

/**
 * 课程章节修改
 * @param {*} query
 */
export const courseChapterUpdate = (query) => {
  return request({
    url: `${prefix}/courseChapter`,
    method: 'put',
    data: query
  })
}
/**
 * 课程章节修改
 * @param {*} query
 */
export const courseTest = (query) => {
  return request({
    url: `${prefix}/courseChapter`,
    method: 'post',
    data: query
  })
}
/**
 * 测试卷创建
 * @param {*} query
 */
export const measureScroll = (query) => {
  return request({
    url: `${prefix}/measureScroll`,
    method: 'post',
    data: query
  })
}

/**
 * 课程章节修改 多行
 * @param {*} query
 */
export const courseChaptersUpdate = (query) => {
  return request({
    url: `${prefix}/courseChapters`,
    method: 'put',
    data: query
  })
}

/**
 * 课程章节状态修改
 * @param {*} query
 */
export const courseChapterUpdateStatus = (query) => {
  return request({
    url: `${prefix}/courseChapter/status`,
    method: 'put',
    data: query
  })
}

/**
 * 课程章节删除
 * @param {*} query
 */
export const courseChapterDestroy = (query) => {
  return request({
    url: `${prefix}/courseChapter`,
    method: 'delete',
    data: query
  })
}

/**
 * 课程分类查询：列表
 * @param {*} query
 */
export const courseCategoryList = (query) => {
  return request({
    url: `${prefix}/course/category/list`,
    method: 'get',
    params: query
  })
}

/**
 * 课程分类查询
 * @param {*} query
 */
export const courseCategoryOne = (query) => {
  return request({
    url: `${prefix}/course/category`,
    method: 'get',
    params: query
  })
}

/**
 * 课程分类创建
 * @param {*} query
 */
export const courseCategoryCreate = (query) => {
  return request({
    url: `${prefix}/course/category`,
    method: 'post',
    data: query
  })
}

/**
 * 课程分类修改
 * @param {*} query
 */
export const courseCategoryUpdate = (query) => {
  return request({
    url: `${prefix}/course/category`,
    method: 'put',
    data: query
  })
}

/**
 * 课程分类删除
 * @param {*} query
 */
export const courseCategoryDestroy = (query) => {
  return request({
    url: `${prefix}/course/category`,
    method: 'delete',
    data: query
  })
}

/**
 * 课程讲义查询：列表
 * @param {*} query
 */
export const courseResourceList = (query) => {
  return request({
    url: `${prefix}/courseResource/list`,
    method: 'get',
    params: query
  })
}

/**
 * 课程讲义查询
 * @param {*} query
 */
export const courseResourceOne = (query) => {
  return request({
    url: `${prefix}/courseResource`,
    method: 'get',
    params: query
  })
}

/**
 * 课程讲义创建
 * @param {*} query
 */
export const courseResourceCreate = (query) => {
  return request({
    url: `${prefix}/courseResource`,
    method: 'post',
    data: query
  })
}

/**
 * 课程讲义修改
 * @param {*} query
 */
export const courseResourceUpdate = (query) => {
  return request({
    url: `${prefix}/courseResource`,
    method: 'put',
    data: query
  })
}

/**
 * 课程讲义修改 多行
 * @param {*} query
 */
export const courseResourcesUpdate = (query) => {
  return request({
    url: `${prefix}/courseResources`,
    method: 'put',
    data: query
  })
}

/**
 * 课程讲义删除
 * @param {*} query
 */
export const courseResourceDestroy = (query) => {
  return request({
    url: `${prefix}/courseResource`,
    method: 'delete',
    data: query
  })
}

/**
 * 课程练习查询：列表
 * @param {*} query
 */
export const coursePaperList = (query) => {
  return request({
    url: `${prefix}/coursePaper/list`,
    method: 'get',
    params: query
  })
}

/**
 * 课程练习查询
 * @param {*} query
 */
export const coursePaperOne = (query) => {
  return request({
    url: `${prefix}/coursePaper`,
    method: 'get',
    params: query
  })
}

/**
 * 课程练习创建
 * @param {*} query
 */
export const coursePaperCreate = (query) => {
  return request({
    url: `${prefix}/coursePaper`,
    method: 'post',
    data: query
  })
}

/**
 * 课程练习修改
 * @param {*} query
 */
export const coursePaperUpdate = (query) => {
  return request({
    url: `${prefix}/coursePaper`,
    method: 'put',
    data: query
  })
}

/**
 * 课程练习修改 多行
 * @param {*} query
 */
export const coursePapersUpdate = (query) => {
  return request({
    url: `${prefix}/coursePapers`,
    method: 'put',
    data: query
  })
}

/**
 * 课程练习删除
 * @param {*} query
 */
export const coursePaperDestroy = (query) => {
  return request({
    url: `${prefix}/coursePaper`,
    method: 'delete',
    data: query
  })
}

/**
 * 课程（查询列表数量）
 * @param {*} query
 */
export const courselistCount = (query) => {
  return request({
    url: `${prefix}/course/listCount`,
    method: 'get',
    params: query
  })
}
/**
 * 测试卷（测试卷详情）
 * @param {*} query
 */
export const measureScrollDetail = (query) => {
  return request({
    url: `${prefix}/measureScroll`,
    method: 'get',
    params: query
  })
}
/**
 * 测试卷（测试卷列表）
 * @param {*} query
 */
export const examItemList = (query) => {
  return request({
    url: `${prefix}/measureScroll/examItem/list`,
    method: 'get',
    params: query
  })
}
/**
 * 测试卷（测试卷题目创建）
 * @param {*} query
 */
export const examItemCreated = (query) => {
  return request({
    url: `${prefix}/measureScroll/examItem`,
    method: 'post',
    data: query
  })
}
/**
 * 测试卷（测试卷题目删除）
 * @param {*} query
 */
export const examItemDete = (query) => {
  return request({
    url: `${prefix}/measureScroll/examItem`,
    method: 'delete',
    data: query
  })
}
/**
 * 测试卷（试卷名称变更）
 * @param {*} query
 */
export const measureScrollPut = (query) => {
  return request({
    url: `${prefix}/measureScroll`,
    method: 'put',
    data: query
  })
}
/**
 * 测试卷（试卷题目修改）
 * @param {*} query
 */
export const examItemPut = (query) => {
  return request({
    url: `${prefix}/measureScroll/examItem`,
    method: 'put',
    data: query
  })
}
/**
 * 测试卷（试卷题目批量修改）
 * @param {*} query
 */
export const examMorePut = (query) => {
  return request({
    url: `${prefix}/measureScroll/examItem/list`,
    method: 'put',
    data: query
  })
}
/**
 * 测试卷（测试卷答案修改）
 * @param {*} query
 */
export const answerPut = (query) => {
  return request({
    url: `${prefix}/measureScroll/examItemAnswer`,
    method: 'put',
    data: query
  })
}
/**
 * 测试卷（测试卷答案批量修改）
 * @param {*} query
 */
export const answerPutList = (query) => {
  return request({
    url: `${prefix}/measureScroll/examItemAnswer/list`,
    method: 'put',
    data: query
  })
}
/**
 * 测试卷（测试卷答案删除）
 * @param {*} query
 */
export const answeDetlte = (query) => {
  return request({
    url: `${prefix}/measureScroll/examItemAnswer`,
    method: 'delete',
    data: query
  })
}
/**
 * 测试卷（测试卷答案创建）
 * @param {*} query
 */
export const answerCreate = (query) => {
  return request({
    url: `${prefix}/measureScroll/examItemAnswer`,
    method: 'post',
    data: query
  })
}

/**
 * 测试卷（现有内容题目复制到测试卷题目接口）
 * @param {*} query
 */
export const copyFromExamItem = (query) => {
  return request({
    url: `${prefix}/measureScroll/examItem/copyFromExamItem`,
    method: 'post',
    data: query
  })
}
 /**
 * 获取主讲老师列表
 * @param {*} query
 */   
export const teacherList = (query) => {
  return request({
    url: `${prefix}/baijia/liveRoom/teacher/list`,
    method: 'get',
    params: query
  })
}
/**
 * 课程章节批量建课建直播间文件导入
 * @param {*} query
 */
export const bulkCreateLiveRoomByFile = (query) => {
  return request({
    url: `${prefix}/courseChapter/bulkCreateLiveRoomByFile`,
    method: 'post',
    data: query
  })
}


/**
 * 原获取直播回放点播token接口
 * @param {*} query
 */
export const getRoomVideoToken = (query) => {
  return request({
    url: `${prefix}/baijia/roomVideo/getRoomVideoToken`,
    method: 'post',
    data: query
  })
}
/**
 * 百家云视频删除（删除指定清晰度转码）
 * @param {*} query video_id 视频id 字符串 必填；definition 清晰度 字符串 单选 必填；type 类型 字符串 单选 必填
 */
export const baijiaVideoRemoveDefinition = (query) => {
  return request({
    url: `${prefix}/baijia/video/removeDefinition`,
    method: 'post',
    data: query
  })
}
/**
 * 百家云视频删除（删除点播源文件）
 * @param {*} query video_id 视频id 字符串 必填
 */
export const baijiaVideoDeleteOriginVideo = (query) => {
  return request({
    url: `${prefix}/baijia/video/deleteOriginVideo`,
    method: 'post',
    data: query
  })
}
